import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { FlexContainer, Spinner } from '@taxdown/piccolo-web';
import { pathNameSelector } from 'Store/modules/router/selectors';
import { AccountProps } from 'Containers/Account/types';
import { routes } from 'Constants/routes';
import { EfirmaUserType, RfcUserType } from 'Types/common';
import SatPassword from './components/SatPassword';
import EfirmaForm from './components/EFirmaForm';
import { useFetchSatUserData } from './hooks';
import ProfileData from './components/ProfileData';

const contentScreens = {
  1: ProfileData,
  2: SatPassword,
  3: EfirmaForm,
};

const ROUTES = [
  {
    route: routes.ACCOUNT,
  },
  {
    route: routes.ACCOUNT_RFC,
  },
  {
    route: routes.ACCOUNT_EFIRMA,
  },
];

const AccountProfile = ({ setSubContent }: AccountProps): JSX.Element => {
  const [screen, setScreen] = useState<number>(1);
  const [satValues, setSatValues] = useState<RfcUserType>();
  const [satEfirmaValues, setSatEfirmaValues] = useState<EfirmaUserType>();
  const path = useSelector(pathNameSelector);
  const { data, isLoading, refetch, isFetching } = useFetchSatUserData();

  useEffect(() => {
    if (path === routes.ACCOUNT) {
      setScreen(1);
      refetch();
    }
  }, [path]);

  useEffect(() => {
    if ((data && data.rfc && data.efirmaIsValid) || (data && data.rfc && data.efirma)) {
      setSatValues({ rfcAndPassword: { rfc: data.rfc, password: data.password || '' } });
      setSatEfirmaValues({
        efirma: {
          certificate: data.efirma ? data.efirma.certificateUrl : '',
          passphrase: data.efirma ? data.efirma.passphrase : '',
          privateKey: data.efirma ? data.efirma.privateKeyUrl : '',
        },
      });
    }
    if (data && data.rfc && !data.efirmaIsValid && !data.efirma) {
      setSatValues({ rfcAndPassword: { rfc: data.rfc, password: data.password || '' } });
      setSatEfirmaValues({
        efirma: {
          certificate: '',
          passphrase: '',
          privateKey: '',
        },
      });
    }
  }, [data]);

  if (isLoading || isFetching || !data) {
    return (
      <FlexContainer justify="center" align="center">
        <Spinner size="M" justify="center" align="center" />
      </FlexContainer>
    );
  }

  const Component = screen && contentScreens[screen];

  return (
    <Switch>
      {ROUTES.map(({ route }) => (
        <Route
          key={route}
          exact
          path={route}
          render={() => (
            <Component
              setScreen={setScreen}
              satValues={satValues}
              satEfirmaValues={satEfirmaValues}
              refetch={refetch}
              setSubContent={setSubContent}
            />
          )}
        />
      ))}
    </Switch>
  );
};

export default AccountProfile;
